<template>
  <div class="account-settings content-box">
    <section class="lang-settings">
      <lang-menu :value="lang" @change="setLanguage"/>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LangMenu from '../components/LangMenu'
import Profile from '../../lib/profile'

export default {
  name: 'AccountSettings',
  components: { LangMenu },

  computed: {
    ...mapState(['user']),
    lang () {
      if (this.user && this.user.settings && this.user.settings.lang) {
        return this.user.settings.lang
      }
      return 'en'
    }
  },

  methods: {
    setLanguage (lang) {
      Profile.setSettings(this.user.id, { lang })
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/styles/vars";

  .account-settings {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    margin-top: -$big-padding;
  }
</style>
